<template>
  <div class="d-flex flex-column align-items-center w-100">

    <!-- HEADER / FILTRES -->
    <div
      class="row mb-3 align-items-center w-100"
      style="background-color:#fcfcfc; padding:20px; border-radius:12px"
    >

      <!-- Switch vue -->
      <div class="col-md-2 d-flex gap-2">
        <button
          class="btn btn-sm rounded-pill px-4"
          :class="viewMode === 'table' ? 'btn-warning' : 'btn-white border'"
          @click="viewMode = 'table'"
          title="Vue tableau"
        >
          <i class="bi bi-table"></i>
        </button>
        <button
          class="btn btn-sm rounded-pill px-4"
          :class="viewMode === 'card' ? 'btn-warning' : 'btn-white border'"
          @click="viewMode = 'card'"
          title="Vue cartes"
        >
          <i class="bi bi-card-text"></i>
        </button>
      </div>

      <!-- Recherche -->
      <div class="col-md-3">
        <input
          v-model="search"
          type="text"
          class="form-control"
          placeholder="Rechercher (nom, email, code...)"
        />
      </div>

      <!-- Résultats -->
      <div class="col-md-2">
        <span class="fw-semibold">
          {{ totalFiltered ?? totalAll }} résultats
        </span>
      </div>

      <!-- Exports -->
      <div class="col-md-5 text-end">
        <button
          class="btn btn-alt-primary rounded-pill me-2 px-4"
          @click="exportCsv"
        >
          CSV
        </button>
        <button
          class="btn btn-alt-primary rounded-pill px-4"
          @click="exportXls"
        >
          Excel
        </button>
      </div>
    </div>

    <!-- ===================== -->
    <!-- ===== CARD VIEW ===== -->
    <!-- ===================== -->
    <div
      v-if="viewMode === 'card'"
      class="row gx-3 w-100 mt-0"
    >
      <div
        class="col-xl-3 col-lg-4 col-md-6"
        v-for="item in items"
        :key="item.id"
      >
        <div
          class="h-100"
          style="background-color:#fcfcfc; padding:20px; border-radius:12px; position:relative"
        >
          <!-- Status -->
          <span
            v-html="item.status"
            style="position:absolute; top:-12px; right:-12px"
          ></span>

          <div class="d-flex flex-column gap-2 text-center">

            <div class="fw-semibold">
              {{ item.first_name }} {{ item.last_name }}
            </div>
            <div class="fw-semibold">
              {{ item.phone_number }}
            </div>
            <div class="fw-semibold">
              {{ item.email }}
            </div>
            <div class="fw-semibold">
              {{ item.birthday }}
            </div>
            <div class="fw-semibold">
              {{ item.loyalty_points }} points
            </div>
            <div
              class="mt-2 d-flex justify-content-center flex-wrap"
              v-html="item.actions"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================== -->
    <!-- ===== TABLE VIEW ==== -->
    <!-- ===================== -->
    <div
      v-if="viewMode === 'table'"
      class="w-100"
      style="background-color:#fcfcfc; padding:20px; border-radius:12px"
    >
      <div class="table-responsive">
        <table class="table table-bordered table-striped table-vcenter last-col-wide">
          <thead>
            <tr>
              <th
                v-for="col in columns"
                :key="col.data"
                class="text-center"
                style="font-size: 18px; width: '00px'"
              >
                {{ col.title }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td
                v-for="col in columns"
                :key="col.data"
                class="text-center"
              >
                <span
                  v-if="col.data === 'send_date' || col.data === 'date_end'"
                >
                  {{ item[col.data]?.display }}
                </span>
                <span v-else v-html="item[col.data]"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- PAGINATION -->
    <div
      class="d-flex justify-content-between align-items-center mt-3 w-100"
    >
      <span>
        {{ totalFiltered }} / {{ totalAll }} résultats
      </span>

      <div>
        <!-- <button
          class="btn btn-sm btn-light"
          :disabled="page === 1 || loading"
          @click="page--"
        >
          Précédent
        </button>

        <button
          class="btn btn-sm btn-light ms-2"
          :disabled="loading || page * perPage >= (totalFiltered ?? totalAll)"
          @click="page++"
        >
          Suivant
        </button> -->
        <nav>
          <ul class="pagination pagination-sm mb-0">

            <!-- Précédent -->
            <li
              class="page-item"
              :class="{ disabled: page === 1 || loading }"
            >
              <button
                class="page-link"
                @click="page--"
                :disabled="page === 1 || loading"
              >
                Précédent
              </button>
            </li>

            <!-- … avant -->
            <li
              v-if="visiblePages[0] > 1"
              class="page-item disabled"
            >
              <span class="ms-2">…</span>
            </li>

            <!-- Pages -->
            <li
              v-for="p in visiblePages"
              :key="p"
              class="page-item"
              :class="{ active: p === page }"
            >
              <button
                class="page-link"
                @click="page = p"
              >
                {{ p }}
              </button>
            </li>

            <!-- … après -->
            <li
              v-if="visiblePages[visiblePages.length - 1] < totalPages"
              class="page-item disabled"
            >
              <span class="ms-2">…</span>
            </li>

            <!-- Suivant -->
            <li
              class="page-item"
              :class="{ disabled: page === totalPages || loading }"
            >
              <button
                class="page-link"
                @click="page++"
                :disabled="page === totalPages || loading"
              >
                Suivant
              </button>
            </li>

          </ul>
        </nav>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    fetchUrl: String,
    exportCsvUrl: String,
    exportXlsUrl: String,
    columns: Array
  },

  data () {
    return {
      items: [],
      page: 1,
      perPage: 10,
      totalAll: 0,
      totalFiltered: null,
      search: '',
      loading: false,
      searchTimeout: null,
      viewMode: 'table'
    }
  },

  watch: {
    page () {
      this.fetchData()
    },

    search () {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.page = 1
        this.fetchData()
      }, 300)
    },

    viewMode (val) {
      localStorage.setItem('voucherViewMode', val)
    }
  },

  mounted () {
    this.viewMode = localStorage.getItem('voucherViewMode') || 'card'
    this.fetchData()
  },

  methods: {
    async fetchData () {
      this.loading = true

      try {
        const params = {
          draw: Date.now(),
          start: (this.page - 1) * this.perPage,
          length: this.perPage,
          'searchc': this.search || '',
          // 'searchc': false
        }

        this.columns.forEach((col, index) => {
          params[`columns[${index}][data]`] = col.data
          params[`columns[${index}][name]`] = col.name || col.data
          params[`columns[${index}][searchable]`] = true
          params[`columns[${index}][orderable]`] = true
        })
        console.log('params', params)
        const response = await axios.get(this.fetchUrl, { params })
        this.items = response.data.data ?? []
        this.totalAll = Number(response.data.recordsTotal ?? 0)
        this.totalFiltered = Number(response.data.recordsFiltered ?? this.totalAll)
      } catch (e) {
        console.error('Erreur chargement', e)
      } finally {
        this.loading = false
      }
    },

    exportCsv () {
      window.location.href = this.exportCsvUrl
    },

    exportXls () {
      window.location.href = this.exportXlsUrl
    }
  },
  computed: {
    totalPages () {
      const total = this.totalFiltered ?? this.totalAll
      return Math.max(1, Math.ceil(total / this.perPage))
    },

    visiblePages () {
      const range = 2 // nombre de pages avant/après la page courante
      const start = Math.max(1, this.page - range)
      const end = Math.min(this.totalPages, this.page + range)

      const pages = []
      for (let i = start; i <= end; i++) {
        pages.push(i)
      }
      return pages
    }
  }
}
</script>
<style>
.page-item.active .page-link {
  background-color: #2F4858 !important;
  border-color: #2F4858 !important;
  color: #fff !important;
  border-radius: 4px !important;
}
</style>
